module.exports = __webpack_public_path__ + "6001cc78cf04aae7a65603c3733c34c6.mtl";